import openalexLogo from '@/assets/openalex-logo.png';
import pubmedLogo from '@/assets/pubmed-logo.png';
import { type Database } from '@ditto/shared';
import { type FC } from 'react';

interface DatabaseLogoProps {
  database: Database;
  className?: string;
  alt?: string;
}

const databaseLogos: Record<Database, string> = {
  pubmed: pubmedLogo,
  openalex: openalexLogo,
};

const databaseNames: Record<Database, string> = {
  pubmed: 'PubMed',
  openalex: 'OpenAlex',
};

export const DatabaseLogo: FC<DatabaseLogoProps> = ({
  database,
  className = 'h-6',
  alt,
}) => {
  const logoSrc = databaseLogos[database];
  const databaseName = databaseNames[database];
  const altText = alt || `${databaseName} Logo`;

  if (!logoSrc) {
    // Fallback for databases without logos
    return (
      <div
        className={`flex items-center justify-center bg-neutral-100 rounded text-xs font-medium text-neutral-600 px-2 ${className}`}
      >
        {database.toUpperCase()}
      </div>
    );
  }

  return <img src={logoSrc} alt={altText} className={className} />;
};
